"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasScopes = void 0;
const _ = require("lodash");
const hasScopes = ({ neededScopes, isOwner, teamMemberScopes, }) => {
    if (!neededScopes) {
        return true;
    }
    if (isOwner)
        return true;
    const hasAllScopes = _.reduce(neededScopes, (acc, scope) => {
        var _a;
        const scopeEnabled = (_a = _.find(teamMemberScopes, (current) => current.id === scope)) === null || _a === void 0 ? void 0 : _a.enabled;
        if (!scopeEnabled) {
            return false;
        }
        return acc;
    }, true);
    return hasAllScopes;
};
exports.hasScopes = hasScopes;
//# sourceMappingURL=authScopes.js.map